import { VoiceConfiguration } from 'shared/interfaces/Voice';
import { axiosBaseInstance } from 'shared/utils/axios-instances';

const voiceBaseEndpoint = '/voice';

export const VoiceService = {
  getVoices: async (): Promise<VoiceConfiguration[]> => {
    const response = await axiosBaseInstance({
      method: 'get',
      url: `${voiceBaseEndpoint}/all`
    });

    return response.data;
  }
};
